
export default {
  name: "SvgNpo3fm",
}
